import { z } from 'zod';
import { PERMISSION_CODES } from '../constants/permissions.js';
/**
 * Remplace intégralement l'ensemble des permissions d'un rôle (matrice
 * rôle × permission de l'écran de gestion des rôles). Le rôle
 * `AGENT_IMMATRICULATION` est rejeté côté serveur, indépendamment de ce schéma
 * (voir apps/api/src/modules/roles).
 */
export const updateRolePermissionsSchema = z.object({
    permissionCodes: z.array(z.enum(PERMISSION_CODES)),
});
//# sourceMappingURL=roles.js.map